import axios from 'axios';
import { apiUrl } from './ApiHost';
import authHeader from './AuthHeader';


class DashboardService {
    getNumberOfClients() {
        return axios.get(apiUrl + 'dashboard/clients', { headers: authHeader() });
    }
    getNumberOfPlans() {
        return axios.get(apiUrl + 'dashboard/plans', { headers: authHeader() });
    }
}

export default new DashboardService();